// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SerializedVariant } from './SerializedVariant';
import {
    SerializedVariantFromJSON,
    SerializedVariantFromJSONTyped,
    SerializedVariantToJSON,
    SerializedVariantToJSONTyped,
} from './SerializedVariant';

/**
 * Input for a reconstructed-method call-through to the device
 * @export
 * @interface ControlCallInput
 */
export interface ControlCallInput {
    /**
     * Full OPC UA browse path of the method
     * @type {string}
     * @memberof ControlCallInput
     */
    browsePath: string;
    /**
     * The method input arguments
     * @type {Array<SerializedVariant>}
     * @memberof ControlCallInput
     */
    inputArguments?: Array<SerializedVariant>;
}

/**
 * Check if a given object implements the ControlCallInput interface.
 */
export function instanceOfControlCallInput(value: object): value is ControlCallInput {
    if (!('browsePath' in value) || value['browsePath'] === undefined) return false;
    return true;
}

export function ControlCallInputFromJSON(json: any): ControlCallInput {
    return ControlCallInputFromJSONTyped(json, false);
}

export function ControlCallInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlCallInput {
    if (json == null) {
        return json;
    }
    return {
        
        'browsePath': json['browsePath'],
        'inputArguments': json['inputArguments'] == null ? undefined : ((json['inputArguments'] as Array<any>).map(SerializedVariantFromJSON)),
    };
}

export function ControlCallInputToJSON(json: any): ControlCallInput {
    return ControlCallInputToJSONTyped(json, false);
}

export function ControlCallInputToJSONTyped(value?: ControlCallInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'browsePath': value['browsePath'],
        'inputArguments': value['inputArguments'] == null ? undefined : ((value['inputArguments'] as Array<any>).map(SerializedVariantToJSON)),
    };
}

